import $axios from '@/plugins/axios';


/**
 * @description 获取游戏列表
 * @param
 */
export function list() {
  return $axios.post('front/gameList');
}

/**
 * @description 获取游戏角色信息
 * @param
 */
export function gameRoleList(alias) {
  return $axios.post(`front/gameRoleList?alias=${alias}`);
}

/**
 * @description 获取游戏区服信息
 * @param
 */
export function gameZoneList(alias) {
  return $axios.post(`front/gameZoneList?alias=${alias}`);
}

/**
 * @description 获取游戏账号信息
 * @param
 */
export function getAccount(params) {
  return $axios.post('front/getGameAccountNew', params);
}
